import axios from 'axios';

const WP_API_URL = process.env.REACT_APP_WP_API_URL + '/wp-json/wp/v2';

const wpAxios = axios.create();
wpAxios.defaults.baseURL = WP_API_URL;

export const getAlerts = async () => {
  try {
    const res = await wpAxios.get(`${WP_API_URL}/alerts`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteDetails = async () => {
  try {
    const res = await wpAxios.get(`${WP_API_URL}/mcwa-settings`);
    const { data } = res;

    const removeEmptyStrings = (obj) => {
      let newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') {
          newObj[prop] = obj[prop];
        }
      });
      return newObj;
    };

    return removeEmptyStrings(data);
  } catch (error) {
    throw error;
  }
};

export const getFaqs = async () => {
  try {
    const res = await wpAxios.get(`${WP_API_URL}/faqs`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// add methods to object to handle warning no-anonymous-default-export
const wpObject = {
  getAlerts,
  getSiteDetails,
  getFaqs,
};

export default wpObject
